import { __assign } from "tslib";
import { FocusTrapManager } from './FocusTrapManager';
import { createGuard, removeElementFromDocument } from './utils';
var FocusTrap = /** @class */ (function () {
    function FocusTrap(manager, scope, options) {
        if (options === void 0) { options = {}; }
        this.options = { autoFocus: true };
        this.active = false;
        this.cleanupFns = [];
        this.manager = manager;
        this.scope = scope;
        this.setOptions(options);
    }
    /**
     * Returns trapped html element.
     */
    FocusTrap.prototype.getScope = function () {
        return this.scope;
    };
    /**
     * Activates focus trap.
     */
    FocusTrap.prototype.activate = function () {
        if (this.active) {
            return;
        }
        this.active = true;
        this.attachGuards();
        this.activateInManager();
    };
    /**
     * Deactivates focus trap.
     */
    FocusTrap.prototype.deactivate = function () {
        if (!this.active) {
            return;
        }
        this.active = false;
        this.cleanupFns.forEach(function (fn) { return fn(); });
        this.cleanupFns = [];
    };
    /**
     * Returns focus trap options.
     */
    FocusTrap.prototype.getOptions = function () {
        return this.options;
    };
    /**
     * Sets focus trap options.
     */
    FocusTrap.prototype.setOptions = function (options) {
        this.options = __assign(__assign({}, this.options), options);
    };
    FocusTrap.prototype.attachGuards = function () {
        var beforeElement = createGuard(1);
        var afterElement = createGuard(0);
        this.scope.insertAdjacentElement('beforebegin', beforeElement);
        this.scope.insertAdjacentElement('afterend', afterElement);
        this.cleanupFns.push(function () {
            removeElementFromDocument(beforeElement);
            removeElementFromDocument(afterElement);
        });
    };
    FocusTrap.prototype.activateInManager = function () {
        var _this = this;
        this.manager.activate(this);
        this.cleanupFns.push(function () {
            _this.manager.deactivate(_this);
        });
    };
    return FocusTrap;
}());
export { FocusTrap };
/**
 * Creates focus trap for selected dom-node.
 *
 * @example
 * createFocusTrap(scopeDomNode, { autoFocus: true })
 */
export function createFocusTrap(scope, options) {
    if (options === void 0) { options = {}; }
    var manager = FocusTrapManager.getInstance();
    return new FocusTrap(manager, scope, options);
}
